import { useEffect, useState } from "react";
import { Music } from "lucide-react";
import api from "@/lib/api";

let _musicTracksCache = null;
export function useMusicTracks() {
  const [tracks, setTracks] = useState(_musicTracksCache || []);
  useEffect(() => {
    if (_musicTracksCache) return;
    api.get("/music-tracks").then((r) => {
      _musicTracksCache = r.data.tracks || [];
      setTracks(_musicTracksCache);
    }).catch(() => {});
  }, []);
  return tracks;
}

export default function MusicPicker({ track, volume, onChange, testid }) {
  const tracks = useMusicTracks();
  return (
    <div className="flex gap-2 items-center">
      <Music className="h-3.5 w-3.5 text-zinc-500 shrink-0" />
      <select
        value={track || ""}
        onChange={(e) => onChange({ track: e.target.value || null, volume: volume || "subtle" })}
        data-testid={testid}
        className="flex-1 min-w-0 bg-[#0A0A0A] border border-white/10 rounded-sm px-2.5 py-2 text-xs focus:outline-none focus:ring-2 focus:ring-blue-500 [color-scheme:dark]"
      >
        <option value="">No background music</option>
        {tracks.map((t) => (
          <option key={t.key} value={t.key}>{t.name} — {t.mood}</option>
        ))}
      </select>
      {track && (
        <select
          value={volume || "subtle"}
          onChange={(e) => onChange({ track, volume: e.target.value })}
          data-testid={`${testid}-volume`}
          className="w-24 shrink-0 bg-[#0A0A0A] border border-white/10 rounded-sm px-2 py-2 text-xs focus:outline-none focus:ring-2 focus:ring-blue-500 [color-scheme:dark]"
        >
          <option value="subtle">Subtle</option>
          <option value="medium">Medium</option>
          <option value="loud">Loud</option>
        </select>
      )}
    </div>
  );
}
